import { bindable, bindingMode, computedFrom } from 'aurelia-framework';
import { StringHelper } from '../../helpers/string-helper';

export class CreditCardExpiration {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) cardExpiration: any;
	currentDate: any;
	months: any;
	years: any;
	selectedMonth: string;
	selectedYear: any;

	constructor() {
		this.currentDate = new Date();
		this.months = this.monthsList();
		this.years = this.yearsList();

		this.selectedMonth = '';
		this.selectedYear = '';
	}

	attached() {
		this.setDefaultExpiration();
	}

	setDefaultExpiration() {
		// javascript Months are 0 based.
		this.selectedMonth = (this.currentDate.getMonth() + 1).toString().padStart(2, '0');
		this.selectedYear = this.currentDate.getFullYear().toString();
	}

	monthsList() {
		let list = [];
		for (let i = 1; i <= 12; i++) {
			list.push(StringHelper.padLeft(i.toString(), '0', 2));
		}

		return list;
	}

	yearsList() {
		let list = [];
		let currentYear = this.currentDate.getFullYear();
		for (let i = 0; i < 20; ++i) {
			list.push(currentYear + i);
		}

		return list;
	}

	@computedFrom('selectedMonth', 'selectedYear')
	get expirationDate() {
		return this.cardExpiration = this.selectedMonth + this.selectedYear % 100;
	}
}
